export default __webpack_public_path__ + "static/top-bg-md-8be6bb22ae9ebc3fa6cb676fca6182cb.png";